<template>
    <section class="get-casedrive-app-section py-3 d-md-none" v-if="isIOS || isAndroid">
        <div class="container">
            <div class="row align-items-center justify-content-center get-app-container">
                <div class="col-7">
                    <h4 class="title">Get the <br class="d-md-none">CaseDrive app</h4>
                </div>
                <div class="col-5 d-flex justify-content-end">
                    <img src="@/sass-template/content/images/app-store.svg" class="img-fluid px-1" alt="" v-if="isIOS"  @click="onAppStoreClick">
                    <img src="@/sass-template/content/images/google-play-store.svg" class="img-fluid px-1" alt="" v-if="isAndroid" @click="onPlayStoreClick">
                </div>
            </div>
       </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';

const isIOS = ref(/iPad|iPhone|iPod/.test(navigator.userAgent));
const isAndroid = ref(/Android/.test(navigator.userAgent));

const onAppStoreClick = () => {
  window.open((process.env.VUE_APP_IPHONE_URL || ''), '_blank');
};

const onPlayStoreClick = () => {
  window.open((process.env.VUE_APP_ANDROID_URL || ''), '_blank');
};

</script>
